"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ieCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var ieCountry = exports.ieCountry = function ieCountry(t) {
  return {
    id: 'IE',
    name: t('Ireland'),
    flag: '🇮🇪',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. SW1A 1AA or SW1W 0NY',
    phonePrefix: '353',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Dublin',
    currency: 'EUR'
  };
};